import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { Grid } from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import moment from "moment";

// UI
// import { SelectInput } from "../../components/SelectInput";
// import { LoadingProgress } from "../../components/LoadingProgress";
// import { MapTable } from "../../components/atoms/tables/TableMap";
import { MapView } from "../../components/MapView";
import { BackdropLoading } from "../../components/BackdropLoading";
import { MapDashboard } from "../../components/MapDashboard";
import { FiltersDeviations } from "../../components/atoms/FiltersDeviations";

// Utils
import { useTranslation } from "react-i18next";
import { CheckResponse } from "../../utils/checkResponse";

// Services
import { AssetApi } from "../../services/AssetApi";
// import { PlotPlanApi } from "../../services/PlotPlanApi";
// import { WorkflowApi } from "../../services/WorkflowApi";

// Styles
import { Container, PageTitle } from "../styles";
import { GridContainer, GridMap } from "./styles";

export const MapPage = (props) => {

  const INITIAL_CENTER = { lat: 4.60971, lng: -74.08175 };
  const INITIAL_ZOOM = 6;

  const { t } = useTranslation();
  const {check} = new CheckResponse();
  // const location = useLocation();

  // const workflowApi = new WorkflowApi();
  // const plotPlanApi = new PlotPlanApi();
  const assetApi = new AssetApi();

  // const [height, setHeight] = useState("calc(100vh - 280px)");
  // const plotPlanDetail = React.useRef({});
  const mapRef = React.useRef(null);

  // const [plants, setPlants] = useState([]);
  // const [plant, setPlant] = useState({})
  const showDetailButton = React.useRef(true)

  // const [positions, setPositions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  // const [selectedTypeArea, setSelectedTypeArea] = useState([]);
  // const [workflowList, setWorkflowList] = useState([])
  // const [selectedWorkflow, setSelectedWorkflow] = useState({})

  const [mapCenter, setMapCenter] = useState(INITIAL_CENTER);
  const [mapZoom, setMapZoom] = useState(INITIAL_ZOOM);
  const [activeMarkerId, setActiveMarkerId] = useState(null);

  // 
  // select presidency
  const [filterPresidency, setFilterPresidency] = useState([]);
  // select core
  const [filterCore, setFilterCore] = useState([]);
  // select sites
  const [filterSites, setFilterSites] = useState([]);
  const [filterCompany, setFilterCompany] = useState([]);
  const [filterContracts, setFilterContracts] = useState([]);
  const [open, setOpen] = useState(false);
  const [switchCompanies, setSwitchCompanies] = useState(false);
  const [dataBarGraphics, setDataBarGraphics] = useState([]);
  const [dataListDeviations, setDataListDeviations] = useState([]);
  const [finalDate, setFinalDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [initialDate, setInitialDate] = useState(moment(finalDate).subtract(1, "months").format("YYYY-MM-DD"));
  const [errorsDate, setErrorsDate] = useState({ startDate: false, endDate: false });

  const [filters, setFilters] = useState({
    vicePresidency: [],
    core: [],
    site: [],
    company: [],
    contracts: [],
    endDate: null,
    startDate: null,
    month: moment().month(),
    year: moment().year(),
  });

  const [searchVicePresidText, setSearchVicePresidText] = useState('');
  const [searchCoreText, setSearchCoreText] = useState('');
  const [searchSiteText, setSearchSiteText] = useState('');
  const [searchCompanyText, setSearchCompanyText] = useState('');
  const [searchContractText, setSearchContractText] = useState('');

  const containsText = (text, search) => text?.toLowerCase().indexOf(search.toLowerCase()) > -1;
  
  // Options Select Sites
  const optionsSites = useMemo(() => filterSites?.filter((option) => containsText(option.name, searchSiteText)) || [],
    [filterSites, searchSiteText]);
  // Options Select Presidency
  const optionsPresidency = useMemo(() => filterPresidency?.filter((option) => containsText(option.name, searchVicePresidText)) || [],
    [filterPresidency, searchVicePresidText]);
  // Options Select Troncal
  const optionsCore = useMemo(() => filterCore?.filter((option) => containsText(option.name, searchCoreText)) || [],
    [filterCore, searchCoreText]);
  // Options Select Company
  const optionsCompany = useMemo(() => filterCompany?.filter((option) => containsText(option.name, searchCompanyText)) || [],
    [filterCompany, searchCompanyText]);
  // Options Select Contract
  const optionsContract = useMemo(() => filterContracts?.filter((option) => containsText(option.code, searchContractText)) || [],
    [filterContracts, searchContractText]);

  const areAllItemsSelected = (filters, options, key, category = null) => {
    const filteredOptions = category ? options.filter(item => item.category.name === category) : options;
    return filters[key].length > 0 && filteredOptions.length > 0 && filters[key].length === filteredOptions.length;
  };

  const isAllSelected = areAllItemsSelected(filters, optionsSites, 'site');
  const isAllSystemsSelected = areAllItemsSelected(filters, optionsSites, 'site', 'Sistema');
  const isAllStationsSelected = areAllItemsSelected(filters, optionsSites, 'site', 'Estación');
  const isAllCoresSelected = areAllItemsSelected(filters, optionsCore, 'core');

  const isAllPresidencySelected = filters.vicePresidency.length === optionsPresidency.length;
  const isAllCompanySelected = filters.company.length === optionsCompany.length;
  const isAllContractSelected = filters.contracts.length === optionsContract.length;

  const handleSwitchCompanies = (event) => {
    setOpen(true);
    let cleanValues = {
      vicePresidency: [],
      core: [],
      site: [],
      company: [],
      contracts: [],
      startDate: null,
      endDate: null,
    };
    setErrorsDate({ startDate: false, endDate: false });
    setDataBarGraphics([]);
    setFilterSites([]);
    setFilterContracts([]);
    setFilters(cleanValues);
    setSwitchCompanies(event);
    setOpen(false);
  };

  const [mapData, setMapData] = useState([]);
  const [isDetailPage, setIsDetailPage] = useState(false)
  // 

  const [formCards, setFormCards] = useState({
    workpermitActive: '',
    fieldWorkers: '',
    workpermitInactive: '',
    gastTest: '',
    lotoActive: '',
    coldFlows: '',
    hotFlows: '',
    electricFlows: '',
    lowLevel: '',
    mediumLevel: '',
    highLevel: '',
    criticalAssets: '',
    nonCriticalAssets: ''
  })

  // async function callWorkflowApi() {
  //   let response = await workflowApi.list();
  //   let result = check(response);

  //   if (result.status) {
  //       let defaultWorkflow = response.data.find((el) => el.default)
  //       if (defaultWorkflow?.id) setSelectedWorkflow(defaultWorkflow)
  //       else setSelectedWorkflow(response.data.find((el) => el.id === 1))
  //       setWorkflowList(response.data)
  //   }
  // }

  // async function loadPlants(id) {
  //   setLoading(true);
  //   setPositions([])

  //   let response = await plotPlanApi.list();
  //   if (response.status === 200) {
  //     const data = response.data ?? [];

  //     const findPlant = data.find(el => el.id === id);
      
  //     if (findPlant) {
  //       await getData(findPlant.id);
  //     }
  //   }
  //   setLoading(false);
  // }

  // async function getData(id) {
  //   let response = await getPlotPlan(id, selectedTypeArea);
  //   // await storeData(response, selectedTypeArea);
  //   setPlants(response?.filter(p => p.latitude != null && p.longitude != null))
  // }

  // async function getPlotPlan(id, typeAreas) {
  //   setLoading(true);
    
  //   let plotPlanCurrent = plotPlanDetail.current;
  //   if (plotPlanDetail.current?.id !== id) {
  //       let response = await plotPlanApi.getById(id, typeAreas);
  //       if (response.status === 200) {
  //           plotPlanCurrent = response.data;
  //       }
  //       else plotPlanCurrent = plotPlanDetail.current;
  //   }

  //   let data = plotPlanCurrent.childNodes || []

  //   const mapPositions = data
  //     ?.filter(p => p.latitude != null && p.longitude != null)
  //     .map(p => ({
  //       id: p.id,
  //       name: p.name ?? p.description ?? `Plot ${p.id}`,
  //       lat: Number(p.latitude),
  //       lng: Number(p.longitude),
  //       workflowDatas: p.workflowDatas ?? [],
  //       nodeLevel: p.nodeLevel,
  //       raw: p
  //     })
  //   );
    
  //   setPositions(mapPositions);
  //   setLoading(false);

  //   return data
  // }

  // const tableData = positions.map((p, index) => {
  //   const count =
  //     p.workflowDatas?.find(w => w.workflow.id === selectedWorkflow?.id)?.count ?? 0;

  //   return {
  //     ...p,
  //     index: index + 1,
  //     count
  //   };
  // });

  // async function handleChangePlants(event) {
  //   clearSelection();
    
  //   // Limpieza del Select
  //   if (!event || !event.id) {
  //     setPlant(null);
  //     showButtonBack.current = false;
  //     setSelected(null);

  //     if (mapRef.current) {
  //       setMapCenter(INITIAL_CENTER);
  //       setMapZoom(INITIAL_ZOOM);
  //     }

  //     await loadPlants(1);
  //     return;
  //   }
  //   setPlant(event)
  //   showButtonBack.current = true;

  //   if (!event?.latitude || !event?.longitude || !mapRef.current) return;
  //   await getPlotPlan(event.id);

  //   const target = {
  //     lat: Number(event.latitude),
  //     lng: Number(event.longitude),
  //   };

  //   setMapCenter(target);
  //   // zoom suave después del desplazamiento
  //   setTimeout(() => {
  //     setMapZoom(18);
  //   }, 300);
  // }

  // function handleSelectMarker(marker) {
  //   setSelected(marker);
  // }

  function handleCloseInfo() {
    clearSelection();
  }

  const getPlantManagementReport = async () => {
    const response = await assetApi.getPlantManagementReport();
    if (response.status === 200) {
      setFilterPresidency(response.data);
      const filterItem = response.data?.find(el => el.id === 1) || [];
      setFilterCore(filterItem.plantTrunks);
    }
  }

  const getPlantManagementCompany = async () => {
    const response = await assetApi.getPlantManagementCompany();
    if (response.status === 200) {
      setFilterCompany(response.data);
    }
  }

  const loadInitialData = async (params = {}) => {
    setLoading(true);
    const response = await assetApi.getData(params);
    if(response.status === 200) {
      console.log("response getData ", response)

      const data = response.data;

      const totals = data.reduce((acc, item) => {
        const d = item.detail || {};

        acc.workpermitActive += d.workpermits || 0;
        acc.workpermitInactive += d.suspendedPermits || 0;
        acc.gastTest += d.gasesPermits || 0;
        acc.lotoActive += d.lotoPermits || 0;
        acc.coldFlows += d.coldPermits || 0;
        acc.hotFlows += d.hotPermits || 0;
        acc.electricFlows += d.electricPermits || 0;
        acc.lowLevel += d.lowPermits || 0;
        acc.mediumLevel += d.mediumPermits || 0;
        acc.highLevel += d.highPermits || 0;
        acc.fieldWorkers += d.fieldWorkers || 0;
        acc.criticalAssets += d.criticalAssets || 0;
        acc.nonCriticalAssets += d.nonCriticalAssets || 0;

        return acc;
      }, {
        workpermitActive: 0,
        fieldWorkers: 0,
        workpermitInactive: 0,
        gastTest: 0,
        lotoActive: 0,
        coldFlows: 0,
        hotFlows: 0,
        electricFlows: 0,
        lowLevel: 0,
        mediumLevel: 0,
        highLevel: 0,
        criticalAssets: 0,
        nonCriticalAssets: 0
      });

      setFormCards(totals);

      // MapData
      const plantsMap = new Map();
      data.forEach(item => {
        const key = `${item.plantId}-${item.plantName}`;
        const d = item.detail || {};

        if (!plantsMap.has(key)) {
          plantsMap.set(key, {
            id: item.plantId,
            name: item.plantName,
            lat: item.latitude ? Number(item.latitude) : null,
            lng: item.longitude ? Number(item.longitude) : null,

            detail: {
              workpermits: 0,
              suspendedPermits: 0,
              gasesPermits: 0,
              lotoPermits: 0,
              coldPermits: 0,
              hotPermits: 0,
              electricPermits: 0,
              lowPermits: 0,
              mediumPermits: 0,
              highPermits: 0,
              fieldWorkers: 0,
              criticalAssets: 0,
              nonCriticalAssets: 0
            }
          });
        }

        const plant = plantsMap.get(key);

        // acumular detail
        plant.detail.workpermits += d.workpermits || 0;
        plant.detail.suspendedPermits += d.suspendedPermits || 0;
        plant.detail.gasesPermits += d.gasesPermits || 0;
        plant.detail.lotoPermits += d.lotoPermits || 0;
        plant.detail.coldPermits += d.coldPermits || 0;
        plant.detail.hotPermits += d.hotPermits || 0;
        plant.detail.electricPermits += d.electricPermits || 0;
        plant.detail.lowPermits += d.lowPermits || 0;
        plant.detail.mediumPermits += d.mediumPermits || 0;
        plant.detail.highPermits += d.highPermits || 0;
        plant.detail.fieldWorkers += d.fieldWorkers || 0;
        plant.detail.criticalAssets += d.criticalAssets || 0;
        plant.detail.nonCriticalAssets += d.nonCriticalAssets || 0;
      });

      const mapData = Array.from(plantsMap.values())
        .filter(p => p.lat && p.lng)
        .map((p, index) => ({
          id: p.id,
          name: p.name,
          lat: p.lat,
          lng: p.lng,
          index: index + 1,
          detail: p.detail
        }));

      setMapData(mapData);
      setIsDetailPage(false)
      showDetailButton.current = true;
      clearSelection()

      // reset zoom map
      setMapCenter(INITIAL_CENTER);
      setMapZoom(INITIAL_ZOOM);
    }
    setLoading(false);
  }

  useEffect(() => {
    
    
    // setSelectedTypeArea([]);
    // let id = location.state?.id || props?.id || 1;
    
    async function fetchData() {
      getPlantManagementReport();
      getPlantManagementCompany();
      loadInitialData()

      clearSelection()
      // await callWorkflowApi()

      // plotPlanDetail.current = props.plotPlansChildren?.find(el => el.id === id);
      // await loadPlants(id)
    }

    fetchData()
  }, []);

  const goToDetail = async (selectedItem) => {
    setLoading(true);
    const response = await assetApi.getDetailData(selectedItem.id);
    if(response.status === 200) {
      const data = response.data;

      const totals = data.reduce((acc, item) => {
        const d = item.detail || {};

        acc.workpermitActive += d.workpermits || 0;
        acc.workpermitInactive += d.suspendedPermits || 0;
        acc.gastTest += d.gasesPermits || 0;
        acc.lotoActive += d.lotoPermits || 0;
        acc.coldFlows += d.coldPermits || 0;
        acc.hotFlows += d.hotPermits || 0;
        acc.electricFlows += d.electricPermits || 0;
        acc.lowLevel += d.lowPermits || 0;
        acc.mediumLevel += d.mediumPermits || 0;
        acc.highLevel += d.highPermits || 0;
        acc.fieldWorkers += d.fieldWorkers || 0;
        acc.criticalAssets += d.criticalAssets || 0;
        acc.nonCriticalAssets += d.nonCriticalAssets || 0;

        return acc;
      }, {
        workpermitActive: 0,
        fieldWorkers: 0,
        workpermitInactive: 0,
        gastTest: 0,
        lotoActive: 0,
        coldFlows: 0,
        hotFlows: 0,
        electricFlows: 0,
        lowLevel: 0,
        mediumLevel: 0,
        highLevel: 0,
        criticalAssets: 0,
        nonCriticalAssets: 0
      });

      setFormCards(totals);

      // MapData
      const plantsMap = new Map();
      data.forEach(item => {
        const key = `${item.plotPlanId}-${item.plotPlanName}`;
        const d = item.detail || {};

        if (!plantsMap.has(key)) {
          plantsMap.set(key, {
            id: item.plotPlanId,
            name: item.plotPlanName,
            lat: item.latitude ? Number(item.latitude) : null,
            lng: item.longitude ? Number(item.longitude) : null,

            detail: {
              workpermits: 0,
              suspendedPermits: 0,
              gasesPermits: 0,
              lotoPermits: 0,
              coldPermits: 0,
              hotPermits: 0,
              electricPermits: 0,
              lowPermits: 0,
              mediumPermits: 0,
              highPermits: 0,
              fieldWorkers: 0,
              criticalAssets: 0,
              nonCriticalAssets: 0
            }
          });
        }

        const plant = plantsMap.get(key);

        // acumular detail
        plant.detail.workpermits += d.workpermits || 0;
        plant.detail.suspendedPermits += d.suspendedPermits || 0;
        plant.detail.gasesPermits += d.gasesPermits || 0;
        plant.detail.lotoPermits += d.lotoPermits || 0;
        plant.detail.coldPermits += d.coldPermits || 0;
        plant.detail.hotPermits += d.hotPermits || 0;
        plant.detail.electricPermits += d.electricPermits || 0;
        plant.detail.lowPermits += d.lowPermits || 0;
        plant.detail.mediumPermits += d.mediumPermits || 0;
        plant.detail.highPermits += d.highPermits || 0;
        plant.detail.fieldWorkers += d.fieldWorkers || 0;
        plant.detail.criticalAssets += d.criticalAssets || 0;
        plant.detail.nonCriticalAssets += d.nonCriticalAssets || 0;
      });

      const mapData = Array.from(plantsMap.values())
        .filter(p => p.lat && p.lng)
        .map((p, index) => ({
          id: p.id,
          name: p.name,
          lat: p.lat,
          lng: p.lng,
          index: index + 1,
          detail: p.detail
        }));

      setMapData(mapData);
      setIsDetailPage(true)
      clearSelection()
      showDetailButton.current = false;

      // reload zoom map
      setZoomMap(selectedItem.lat, selectedItem.lng)
    }
    setLoading(false);
  }

  async function setZoomMap(latitude, longitude) {
    const target = {
      lat: Number(latitude),
      lng: Number(longitude),
    };

    setMapCenter(target);
    // zoom suave después del desplazamiento
    setTimeout(() => {
      setMapZoom(18);
    }, 300);
  }

  function clearSelection() {
    setActiveMarkerId(null);
    setSelected(null);
  }

  function toggleMarker(item) {

    // Si ya está activo, se desmarca
    if (activeMarkerId === item.id) {
      clearSelection()
      return;
    }

    // Activar marcados
    setActiveMarkerId(item.id);
    setSelected(item);
  }

  // Auxiliar functions for handleChangeFilters - Childrens
  const handleDateChange = (date) => {
    const formattedDate = moment(new Date(date));
    return formattedDate.isValid() ? formattedDate.format("YYYY-MM-DD") : null;
  };

  const handleSiteChange = (value, optionsSites) => {
    if (value[value.length - 1] === 'selectAll') {
      return { site: isAllSelected ? [] : optionsSites };
    } else if (value[value.length - 1] === 'AllSystems') {
      const systemSites = filterSites.filter(site => site.category.name === 'Sistema');
      return { site: isAllSystemsSelected ? [] : systemSites };
    } else if (value[value.length - 1] === 'AllStations') {
      const stationSites = filterSites.filter(station => station.category.name === 'Estación');
      return { site: isAllStationsSelected ? [] : stationSites };
    }
    return { site: value };
  };

  // Función actualizada para handleVicePresidencyChange
  const handleVicePresidencyChange = (value, optionsPresidency) => {
    const isAllSelected = value[value.length - 1] === 'allPresidency';
    let allPlantTrunks = [];

    if (isAllSelected) {
      allPlantTrunks = isAllPresidencySelected ? [] : optionsPresidency.flatMap(el => el.plantTrunks);
    } else {
      allPlantTrunks = value.flatMap(item => item.plantTrunks || []);
    }

    setFilterCore(allPlantTrunks);

    const selectedTrunksIds = allPlantTrunks.map(trunk => trunk.id);
    const filteredPlants = filterSites.filter(plant => selectedTrunksIds.includes(plant.plantTrunk.id));

    setFilterSites(filteredPlants);

    // Limpiar filtros troncales y plantas en caso de que se desmarquen vicepresidencias
    const updatedCore = filters.core?.filter(core => allPlantTrunks.some(trunk => trunk.id === core.id));
    const updatedSites = filters.site?.filter(site => filteredPlants.some(plant => plant.id === site.id));

    return {
      vicePresidency: isAllSelected ? (isAllPresidencySelected ? [] : optionsPresidency) : value,
      core: updatedCore,
      site: updatedSites,
    };
  };


  const handleCoreChange = (value, optionsCore) => {
    const isAllSelected = value[value.length - 1] === 'AllCore';
    const allPlants = filterPresidency.flatMap(item => item.plants);
    let arrPlantsSelected = [];

    if (isAllSelected) {
      arrPlantsSelected = isAllCoresSelected ? [] : allPlants.filter(plant =>
        optionsCore?.some(troncal => troncal.id === plant.plantTrunk.id)
      )
    } else {
      arrPlantsSelected = allPlants.filter(plant =>
        value?.some(troncal => troncal.id === plant.plantTrunk.id)
      )
    }

    setFilterSites(arrPlantsSelected);

    // limpiar filtro plantas en caso de que se desmarquen las opciones en troncales
    const updatedSites = filters.site?.filter(site =>
      arrPlantsSelected.some(el => el.plantTrunk.id === site.plantTrunk.id)
    )

    return {
      core: isAllSelected ? (isAllCoresSelected ? [] : optionsCore) : value,
      site: updatedSites,
    }
  };

  const handleCompanyChange = (value, optionsCompany) => {
    const isAllSelected = value[value.length - 1] === 'allCompany';
    let allContracts = [];

    if (isAllSelected) {
      allContracts = isAllCompanySelected ? [] : optionsCompany.flatMap(el => el.contracts);
    } else {
      allContracts = value.flatMap(item => item.contracts || []);
    }
    setFilterContracts(allContracts);

    const updateContracts = filters.contracts?.filter(el => allContracts.some(item => item.id === el.id))

    return {
      company: isAllSelected ? (isAllCompanySelected ? [] : optionsCompany) : value,
      contracts: updateContracts,
    }
  }

  const handleContractChange = (value, optionsContract) => {
    if (value[value.length - 1] === 'allContracts') {
      return { contracts: isAllContractSelected ? [] : optionsContract };
    }
    return { contracts: value };
  }

  // Clear all filters
  const handleClearFilters = () => {
    let clean = {
      vicePresidency: [],
      core: [],
      site: [],
      company: [],
      contracts: [],
      startDate: null,
      endDate: null,
      month: moment().month(),
      year: moment().year(),
    }
    setErrorsDate({ startDate: false, endDate: false });
    setDataBarGraphics([]);
    setDataListDeviations([]);
    setFilterSites([]);
    setFilterContracts([]);
    setFinalDate('');
    setInitialDate('');
    setFilters(clean);
  }

  // HandleChange filters - Parent
  const handleChangeFilters = (e, name, type) => {
    let value;

    if (type === "checkbox") {
      value = e.target.checked;
      handleSwitchCompanies(value);
      return
    } else if (type === "date") {
      value = handleDateChange(e);

      if (name === "endDate" && filters.startDate && dayjs(value).isBefore(filters.startDate)) {
        // Si la fecha "hasta" es menor que la fecha "desde", limpiar el valor de "endDate"
        setFilters(prevFilters => ({ ...prevFilters, endDate: null }));
        setErrorsDate(prev => ({ ...prev, endDate: true }));
      } else if (name === "startDate" && filters.endDate && dayjs(filters.endDate).isBefore(value)) {
        // Si la fecha "hasta" existente es menor que la nueva "startDate", limpiar "endDate"
        setFilters(prevFilters => ({ ...prevFilters, startDate: value, endDate: null }));
        setErrorsDate(prev => ({ ...prev, endDate: true }));
      } else {
        // Si la validación pasa, actualizar el filtro y limpiar el error
        setFilters(prevFilters => ({ ...prevFilters, [name]: value }));
        setErrorsDate(prev => ({ ...prev, [name]: false }));
      }
    } else {
      value = e?.target?.value;

      let newFilters;
      switch (name) {
        case 'site':
          newFilters = handleSiteChange(value, optionsSites);
          break;
        case 'vicePresidency':
          newFilters = handleVicePresidencyChange(value, optionsPresidency);
          break;
        case 'core':
          newFilters = handleCoreChange(value, optionsCore);
          break;
        case 'company':
          newFilters = handleCompanyChange(value, optionsCompany);
          break;
        case 'contracts':
          newFilters = handleContractChange(value, optionsContract);
          break;
        default:
          newFilters = { [name]: value };
      }

      setFilters(prevFilters => ({ ...prevFilters, ...newFilters }));
      return;
    }

    setFilters(prevFilters => ({ ...prevFilters, [name]: value }));
  };

  const handleSendFilters = async (e) => {
    e.preventDefault();
    setOpen(true);

    const { year, month, vicePresidency, core, site, company, contracts } = filters;

    const prepareFilters = (additionalFilters = {}) => ({
      managementIds: vicePresidency.map(el => el.id),
      trunkIds: core.map(el => el.id),
      plantIds: site.map(el => el.id),
      companyIds: company.map(el => el.id),
      contractIds: contracts.map(el => el.id),
      ...additionalFilters
    });

    try {
      await loadInitialData(prepareFilters())

    } catch (error) {
      console.error('Error fetching data', error);
    } finally {
      setOpen(false);
    }
  };

  return (
    <Container open={props.open} sx={{ marginBottom: '0px' }}>
      
      <Grid container spacing={2}>

        <Grid item xs={12} sm={3} lg={2} xl={1}>
          <PageTitle>{t('map.title')}</PageTitle>
        </Grid>

        <Grid item xs={12} sm={9} lg={10} xl={11} mb={2}>
          <FiltersDeviations
            switchCompanies={true}
            filters={filters}
            initialDate={initialDate}
            finalDate={finalDate}
            handleChangeFilters={handleChangeFilters}
            handleClearFilters={handleClearFilters}
            setSearchVicePresidText={setSearchVicePresidText}
            setSearchCoreText={setSearchCoreText}
            setSearchSiteText={setSearchSiteText}
            optionsPresidency={optionsPresidency}
            optionsSites={optionsSites}
            optionsCore={optionsCore}
            isAllSelected={isAllSelected}
            isAllCoresSelected={isAllCoresSelected}
            isAllPresidencySelected={isAllPresidencySelected}
            isAllSystemsSelected={isAllSystemsSelected}
            isAllStationsSelected={isAllStationsSelected}
            isAllCompanySelected={isAllCompanySelected}
            isAllContractSelected={isAllContractSelected}
            optionsCompany={optionsCompany}
            optionsContract={optionsContract}
            setSearchCompanyText={setSearchCompanyText}
            setSearchContractText={setSearchContractText}
            filterCore={filterCore}
            filterSites={filterSites}
            filterContracts={filterContracts}
            handleSendFilters={handleSendFilters}
            errorsDate={errorsDate}
          />
        </Grid>
      </Grid>

      <BackdropLoading open={loading}/>

      <GridContainer container>
        <Grid item xs={12} md={8} sx={{ pr: {xs: 0, md: 2}, pb: {xs: 2, md: 0} }}>
          <MapView 
            mapRef={mapRef}
            mapCenter={mapCenter}
            mapZoom={mapZoom}
            // tableData={tableData}
            tableData={mapData}
            selected={selected}
            activeMarkerId={activeMarkerId}
            onMarkerClick={toggleMarker}
            onCloseInfo={handleCloseInfo}
            goToDetail={goToDetail}
            isDetailPage={isDetailPage}
            handleSendFilters={handleSendFilters}
            showDetailButton={showDetailButton.current}
            // loadWorkflowCount={getWorkflowCount}
          />
        </Grid>

        <GridMap item xs={12} md={4}>
          <MapDashboard data={formCards}/>
        </GridMap>
      </GridContainer>

    </Container>
  );
};
